import { Link } from 'react-router';

/**
 * Where the picture in the reminder email leads. Mail clients do not play video, so the email
 * shows a still with a play button on it and this is the page that actually plays.
 *
 * Open without a session, like the unsubscribe screen — see the routing in `App.tsx`. Anybody who
 * taps the picture in the email should see the video at once, and a sign-in form in front of a
 * welcome would be the wrong way round. The file is a static one beside the app, so the web server
 * answers the range requests a phone's player makes for it.
 */
export function WelcomeVideoPage() {
  return (
    <main className="px-gutter flex min-h-dvh items-center justify-center py-8">
      <div className="rounded-card w-full max-w-2xl border border-border bg-surface p-5">
        <img src="/logo-lockup.png" alt="Go for the Greens" width={150} height={98} />

        <h1 className="font-display text-screen-title mt-4 font-semibold text-ink">
          Welcome to Go for the Greens
        </h1>

        <video
          className="mt-4 aspect-video w-full rounded-well bg-ink"
          src="/media/welcome.mp4"
          poster="/media/welcome-cover.jpg"
          controls
          playsInline
          preload="metadata"
        />

        <p className="text-body mt-4 text-ink-3">
          Your agenda, who else is coming and your badge are all in the app. Fill in your profile
          before you arrive, so we can introduce you to the people you most want to meet.
        </p>

        <Link
          to="/"
          className="text-button rounded-button mt-5 flex min-h-touch w-full items-center justify-center bg-ink px-4 font-semibold text-white"
        >
          Open the app
        </Link>
      </div>
    </main>
  );
}
